export default {
	ADD_NOTIFICATION: '@@notifications/ADD_NOTIFICATION',
	EDIT_NOTIFICATION: '@@notifications/EDIT_NOTIFICATION',
	REMOVE_NOTIFICATION: '@@notifications/REMOVE_NOTIFICATION',
	CLEAR_ALL: '@@notifications/CLEAR_ALL'
}
